import axios from "axios";
import { User } from "../types";

//let ApiURL = "http://localhost:8080/portal-fornecedores/api"
let ApiURL = "https://www.urbamsjc.com.br/portal-fornecedores/api";
// if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
//   ApiURL = "http://localhost:8080/api";
// }

export const api = (user: User | undefined = undefined) =>
  axios.create({
    baseURL: ApiURL,
    method: "POST",
    headers: {
      content: "application/json",
      Authorization: user ? `Bearer ${user.accessToken}` : "",
    },
  });
export const apiBlob = (user: User | undefined = undefined) =>
  axios.create({
    baseURL: ApiURL,
    method: "POST",
    responseType: "blob",
    headers: {
      content: "application/json",
      Authorization: user ? `Bearer ${user.accessToken}` : "",
    },
  });
